import React from 'react'
import {PinchView} from 'react-pinch-zoom-pan'
import { url } from '../../utils/variables'
export default function ImageZoom({imgUid}) {
    return(
        <PinchView backgroundColor='#717171' initalScale={1} maxScale={4} containerRatio={1000}>
            <img src={`${url}/files?uid=${imgUid}`} alt='img'/>
        </PinchView> 
    )
}